// extracted by mini-css-extract-plugin
export var label = "_fc-5";
export var slideContainer = "_fc-0";
export var slider = "_fc-1";
export var sliderLg = "_fc-4";
export var sliderMd = "_fc-3";
export var sliderSm = "_fc-2";